import MatchHelper from './MatchHelper';
import { RelatedObjI, StatusI } from './Statuses';
import { TicketType } from './TicketTypeHelper';

export interface StatusTimeI {
  [stutus: string]: {
    [ticketType: string]: string | null;
  };
}

export interface EachInboxesStatusTimeI {
  inboxes: string[];
  statusTime: StatusTimeI;
}
export declare type AllInboxesStatusTimeI = EachInboxesStatusTimeI[];

class AllInboxesStatusTime {
  data: AllInboxesStatusTimeI;
  constructor(data: AllInboxesStatusTimeI) {
    this.data = data;
  }
  static getDefault(): AllInboxesStatusTimeI {
    return [];
  }
  update(
    relatedObj: RelatedObjI, // { [status]: TicketType[] }
    inboxes: string[],
    time: string | null,
    returnModel = false,
  ): AllInboxesStatusTime | AllInboxesStatusTimeI {
    let newData = this.data;
    const hasAny = newData.some((d) =>
      MatchHelper.matchedExactInboxes(d.inboxes, inboxes),
    );
    if (!hasAny) {
      newData = newData.concat({
        inboxes,
        statusTime: {},
      });
    }
    newData = newData.map((d) => {
      if (MatchHelper.matchedExactInboxes(d.inboxes, inboxes)) {
        const newStatusTime = Object.entries(relatedObj).reduce(
          (acc, [status, ticketTypes]) => {
            if (!(status in acc)) {
              acc[status] = {};
            }
            acc[status] = ticketTypes.reduce(
              (acc2, ticketType) => ({
                ...acc2,
                [ticketType]: time,
              }),
              acc[status],
            );
            return acc;
          },
          { ...d.statusTime },
        );
        return {
          ...d,
          statusTime: newStatusTime,
        };
      }
      return d;
    });
    this.data = newData;
    return returnModel ? this : this.data;
  }
  getStatusTime(inboxes: string[]): StatusTimeI | undefined {
    return this.data.find((d) =>
      MatchHelper.matchedExactInboxes(d.inboxes, inboxes),
    )?.statusTime;
  }
  getStatusTimeForStatusTicketType(
    inboxes: string[],
    status: StatusI,
    ticketType: TicketType,
  ): string | null {
    const statusTime = this.getStatusTime(inboxes);
    if (!statusTime) return null;
    return (
      (statusTime[status] && statusTime[status][ticketType]) ?? null
    );
  }
}

export { AllInboxesStatusTime };
